export default "__VITE_ASSET__dOKle_Qc__"